/**
 * Klab Organization API
 *
 * Contact: josealejandro2901@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Scope of the holiday. NATIONAL applies org-wide; REGIONAL is by location.
 */
export const HolidayScopeEnum = {
    National: 'NATIONAL',
    Regional: 'REGIONAL'
} as const;
export type HolidayScopeEnum = typeof HolidayScopeEnum[keyof typeof HolidayScopeEnum];
